export const parseSlashDateUtc = dateString => {
  if (!dateString) {
    return null
  }
  if (dateString.includes('-')) {
    const [year, month, day] = dateString.split('-').map(Number)
    if (!year || !month || !day) {
      return null
    }
    return Date.UTC(year, month - 1, day)
  }
  const [month, day, year] = dateString.split('/').map(Number)
  if (!month || !day || !year) {
    return null
  }
  const fullYear = year < 100 ? 2000 + year : year
  return Date.UTC(fullYear, month - 1, day)
}

export const getTodayUtc = () => {
  const now = new Date()
  return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
}

export const getSortedDateEntriesUtc = dates => {
  if (!Array.isArray(dates) || dates.length === 0) {
    return []
  }
  return dates
    .map(dateEntry => ({
      dateEntry,
      start: parseSlashDateUtc(dateEntry.startDate),
    }))
    .filter(({ start }) => start !== null)
    .sort((a, b) => a.start - b.start)
}

export const getSortedDateEntriesUtcWithEnd = dates => {
  if (!Array.isArray(dates) || dates.length === 0) {
    return []
  }
  return dates
    .map(dateEntry => ({
      dateEntry,
      start: parseSlashDateUtc(dateEntry.startDate),
      end: parseSlashDateUtc(dateEntry.endDate),
    }))
    .filter(({ start }) => start !== null)
    .sort((a, b) => a.start - b.start)
}

export const getDateEntriesFromNextUtc = (dates, todayUtc) => {
  if (!Array.isArray(dates) || dates.length === 0) {
    return []
  }
  const sortedDates = getSortedDateEntriesUtc(dates)
  if (sortedDates.length === 0) {
    return []
  }
  const nextIndex = sortedDates.findIndex(({ start }) => start > todayUtc)
  if (nextIndex === -1) {
    return []
  }
  return sortedDates.slice(nextIndex).map(({ dateEntry }) => dateEntry)
}
